export const iconFontAwesomeSocialVideo = (
	<i className="fa-solid fa-video"></i>
);
